import {roles} from "../lib/roles"

export const navigationRoutes = {
    [roles.ROLE_ADMINISTRATOR]: [
        {path: '/documente', label: 'Documente'},
        {path: '/reguli', label: 'Reguli'},
        {path: '/reguliArticole', label: 'Reguli Articole'},
        {path: '/parteneri', label: 'Parteneri'},
        {path: '/setari', label: 'Setări'},
    ],
    [roles.ROLE_CONTROLER]: [
        {path: '/documente', label: 'Documente'},
        {path: '/reguli', label: 'Reguli'},
        {path: '/parteneri', label: 'Parteneri'},
        {path: '/reguliArticole', label: 'Reguli Articole'},
    ],
    [roles.ROLE_MANAGER]: [
        {path: '/documente', label: 'Documente'},
        {path: '/parteneri', label: 'Parteneri'}
    ],
    [roles.ROLE_OPERATIONAL]: [
        {path: '/documente', label: 'Documente'},
    ],
    [roles.ROLE_GUEST]: [
        {path: '/documente', label: 'Documente'},
    ]
}
